import $ from 'jquery';
import React from 'react';
import RestClient from '../rest/RestClient';
import Config from '../Config';
import CommonHelper from '../helpers/CommonHelper';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';

export default class Purchase extends React.Component {

  OBTAIN = {
    PURCHASE:   'PURCHASE',
  }

  singleObtainQueriesDone = {};
  id_waitForObtain = null;

  constructor(props) {
    super(props);

    this.state = {
      roleDescription : '?',
      htmlResponse: 'Please wait...'

    };
  }

  submit(){
    $("form[name='paypal_form']").submit();

  }
  rawMarkup(){
          var rawMarkup = this.state.htmlResponse;
          return { __html: rawMarkup };

      }

  componentDidMount() {
    this.id_waitForObtain = setInterval(() =>
    {
      if(RestClient.allowedNonEnterQueries()){
        clearInterval(this.id_waitForObtain);
        this.runObtain(this.OBTAIN.PURCHASE);
      }
    }, 50); // n milliseconds
  }

  runObtain(name){

    var id = null;
    var fn = null;

    var dt = Config.dtBetweenRestAttempts*1000;
    switch (name) {
      case this.OBTAIN.PURCHASE:      //fn=this.obtainUserInfo;
        this.obtainPurchase(); id = setInterval(() => {this.obtainPurchase()}, dt); break;

       default: return; break;
    }

    if(CommonHelper.isNull(this.singleObtainQueriesDone[name])){
        this.singleObtainQueriesDone[name] = {id:null, done:false};
    }

    this.singleObtainQueriesDone[name]['id'] = id;
  }

  cancelObtain(name){
    clearInterval(this.singleObtainQueriesDone[name]['id']);
  }

  obtainPurchase(){
    RestClient.purchase(
      this.props.match.params.id,
      (data)=>{

        this.cancelObtain(this.OBTAIN.PURCHASE);
        this.setState({htmlResponse:data['html']});

        //setTimeout(this.submit(), 3000);
        setTimeout(this.submit(), 2000);
      },
      ()=>{

      }
    );

  }

  render() {
    return (
      <Container align="center" className='text-page'>
        <Row>
        <span dangerouslySetInnerHTML={this.rawMarkup()} />
        </Row>
      </Container>
    )
  }
}
